import { Component, computed, ElementRef, input, output, signal, viewChild } from '@angular/core';
import { GROW } from '../../../../common/animations/animations';
import {
  CheckboxComponent,
  CheckboxSelectionChangedEvent,
} from '../../../../common/components/checkbox/checkbox.component';
import { StoreService } from '../../../../store/store.service';
import { CommonService } from '../../../../common/services/common.service';
import { CalendarService } from '../../../../common/services/calendar.service';
import { ButtonGroupComponent, ButtonItem } from '../../../../common/components/button-group/button-group.component';
import { RouterService } from '../../../../common/services/router.service';
import { ToggleComponent } from '../../../../common/components/toggle/toggle.component';

@Component({
  standalone: true,
  imports: [CheckboxComponent, ToggleComponent, ButtonGroupComponent],
  selector: 'app-day-use-rooms',
  templateUrl: 'day-use-rooms.component.html',
  styleUrl: 'day-use-rooms.component.scss',
  animations: [GROW],
})

export class DayUseRoomsComponent {
  // Inputs
  public readonly isSidePanel = input<boolean>(false);
  public readonly isCalendarSidepanel = input<boolean>(false);

  // Outputs
  public readonly closeModalEvent = output<void>();

  // Signals
  public readonly isDayUseRoomsEnabled = signal<boolean>(false);

  // Computed Signals
  public readonly dayUseRoomsToggle = computed(() => {
    const label = this.storeSvc.localeObj()?.tf_4_ratecalendar_day_use_rooms;
    const isDayUseRoomsEnabled = this.storeSvc.appStore.isDayUseRoomsEnabled();
    const isUpperCaseLabel = this.storeSvc.propInfo()?.isUpperCaseLabel ?? false;

    return {
      label: this.commonSvc.getUpperCaseString(isUpperCaseLabel, label),
      id: 'day-use-rooms',
      selected: isDayUseRoomsEnabled,
    };
  });
  public readonly btnGroupOptions = computed<ButtonItem[]>(() => {
    const localeObj = this.storeSvc.localeObj();
    return [
      {
        label: localeObj?.tf_1_Calendar_rateCalender_btn_cancel,
        variant: 'secondary',
        id: 'back-to-offers',
        value: 'CANCEL',
      },
      {
        label: localeObj?.tf_1_Calendar_rateCalender_btn_save,
        variant: 'primary',
        id: 'proceed-to-book-and-join',
        value: 'SAVE',
      },
    ];
  });

  public readonly isMobileLarge = computed(() => {
    return (this.storeSvc.res()?.mobileLarge) ?? false;
  });

  // View Child
  public readonly footerEle = viewChild<ElementRef>('footer');

  constructor(
    public readonly storeSvc: StoreService,
    public readonly commonSvc: CommonService,
    public readonly calendarSvc: CalendarService,
    public readonly routerSvc: RouterService,
  ) { }

  public onDayUseRoomsToggleSelectionChanged(event: boolean) {
    this.calendarSvc.saveChangesToDayUseRooms(event);
  }

  public onDayUseRoomsSelectionChanged(event: CheckboxSelectionChangedEvent) {
    if (!event.isInitialSelection) {
      this.isDayUseRoomsEnabled.set(event.options[0].selected ?? false);
      if (!this.isSidePanel()) {
        this.handleAction('SAVE');
      }
    }
  }

  public get isSearchPage() {
    return this.routerSvc.isSearchPage;
  }

  public get isRoomsPage() {
    return this.routerSvc.isRoomsPage;
  }

  public get isSpecialsPage() {
    return this.routerSvc.isSpecialsPage;
  }

  public handleAction = (action: 'CANCEL' | 'SAVE') => {
    if (action === 'SAVE' && !this.isCalendarSidepanel()) {
      this.calendarSvc.saveChangesToDayUseRooms(this.isDayUseRoomsEnabled());
      this.isSearchPage && this.calendarSvc.refreshCalendar();
      this.isRoomsPage && this.storeSvc.checkinSummaryUpdated$.next(true);
      this.isSpecialsPage && this.storeSvc.checkinSummaryUpdated$.next(true);
    }

    this.closeModalEvent.emit();
  };
}